import React, { useEffect } from "react";
import _ from "lodash";

import logo from "assets/images/sbs/tot-new/tot-logo.png";
import guesser from "assets/images/sbs/tot-new/guesserr.png";
import clueGiver from "assets/images/sbs/tot-new/clue-giver.png";

import skippedImg from "assets/images/sbs/tot-new/skipped.png";
import scoredImg from "assets/images/sbs/tot-new/Scored.png";

const Skipped = ({
  skipped,
  isGuesser,
  scorerName,
  setTotMessage,
  guessing_params
}) => {
  const by = _.get(guessing_params, "by", "by:");

  useEffect(() => {
    setTimeout(() => {
      setTotMessage("");
    }, 1100);
  }, []);

  return (
    <div className="skipped-screen">
      <img src={logo} alt="logo" className="logo logo-tot" />
      <img
        src={isGuesser ? guesser : clueGiver}
        alt="logo"
        className="guesser"
      />
      <img
        src={skipped ? skippedImg : scoredImg}
        alt="logo"
        className="skipped-img"
      />
      <div className="by">
        <p>{by}</p>
        <h4 className="name">{scorerName}</h4>
      </div>
    </div>
  );
};

export default Skipped;
